/* import __COLOCATED_TEMPLATE__ from './loading-prescreener.hbs'; */
import Component from '@glimmer/component';
import styles from './loading-prescreener.module.scss';

export default class RequestStepsLoadingLoadingPrescreener extends Component {
  styles = styles;
}
